import styled from 'styled-components';

export const FormStyleButton = styled.div`
  .button-primary {
    background-color: ${(props) => (props.theme.primary)} !important;
    color: #000000
  }

  .button-secondary {
    background-color: ${(props) => (props.theme.buttonSecondary)} !important;
    color: #ffffff
  }

  .button-terciario {
    background-color: ${(props) => (props.theme.buttonTerciario)} !important;
    color: #ffffff
  }

  .button-white {
    color: ${(props) => (props.theme.whiteButton)} !important;
  }
`;
